import { defineComponent } from 'vue';
import FilterSorting from '@/components/Blue/ProductListing/FilterSorting.vue';
import { mapGetters } from 'vuex';
import ListingFilters from '@/components/Blue/ProductListing/ListingFilters.vue';
export default defineComponent({
    name: 'mobile-filter-header-menu',
    components: {
        ListingFilters,
        FilterSorting,
    },
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        appliedFilters: 'appliedFilters',
        priceBars: 'priceBars',
        currentListingType: 'getListingType',
    })), { isSearch() {
            return this.currentListingType === 'search';
        },
        appliedFiltersLength() {
            return (this.appliedFilters.conditions.length +
                this.appliedFilters.brands.length +
                (this.appliedFilters.isDeal ? 1 : 0));
        } }),
});
